<template>
    <div :class="fieldClass" v-if="field.display">
        <label :for="field.title">{{ fieldTitle }}<span v-if="field.required">*</span></label>
        <span v-if="field.type=='select'">
            <select v-model="field.value" v-validate="validationTypes" :name="this.field.title">
                <option value="" disabled>{{ $t('selectChooseOption') }} </option>
                <option :key="option" v-for="option in field.options" :value="$t(option)">{{ $t(option) }}</option>    
            </select>
        </span>
        <span v-else-if="field.type=='date'">
            <app-date-picker :data-vv-scope="validationScope" :data-vv-name="this.field.title" v-validate="validationTypes" v-model="field.value" :validationScope="validationScope" :field="field"></app-date-picker>
        </span>
        <span v-else>
            <input data-vv-validate-on="blur" v-model="field.value" v-validate="validationTypes" type="text" :name="this.field.title" />
        </span>
        <span class="cst-survey-customer-field-error" v-show="errors.has(validationFieldName)">{{ errors.first(validationFieldName) }}</span>
    </div>
</template>

<script>
    
    import AppDatePicker from './AppDatePicker.vue'

    export default {
      props: ['field', 'validationScope'],
      inject: ['$validator'],
      computed: {
        fieldTitle: function () {
          return this.$t(this.field.title)
        },
        fieldClass: function () {
          return 'cst-survey-customer-field cst-survey-customer-field-' + this.field.title
        },
        validationFieldName: function () {
          return this.validationScope + '.' + this.field.title
        },
        validationTypes: function () {
          let validations = {}
          if (this.field.required) {
            validations.required = true
          }
          if (this.field.type === 'email') {
            validations.email = true
          }
          return validations
        }
      },
      components: {
        AppDatePicker
      }
    }
</script>

<style lang="less" scoped>
    @import '../_theme';

     .cst-survey-customer-field input {
        .text-input;
     }

    .cst-survey-customer-field-error {
        .cst-field-error
    }
    .cst-survey-customer-field {
        width: 33%;
        display: inline-block;
        margin-right: 5%;
        margin-bottom: 1em;
    }
    .cst-survey-customer-field label {
        font-size: 80%;
        margin-bottom: 0.2em;
        display: inline-block;
    }
    .cst-survey-customer-field-customerEmail {
        width: 71.5%;
    }
    p {
        display: block;
        margin-bottom: 5%;
    }
    @media (max-width: 1000px) {
        .cst-survey-customer-field, .cst-survey-customer-field-customerEmail {
            width: 100%;
            margin-bottom: 0.9em;
        }
    }

    @media (min-width: 1000px) and (max-width: 1300px) {
        .cst-survey-customer-field, .cst-survey-customer-field-customerEmail {
            width: 43%;
            margin-bottom: 0.9em;
        }
    }    

</style>

<style>
    .cst-survey-customer-field input, .cst-survey-customer-field select {
        width: 100%;
        padding: 0.4em;
        margin: 0;
        height: 2.4em;
        box-sizing: border-box;
    }
</style>



// WEBPACK FOOTER //
// src/components/CustomerField.vue